<script>
  import { createEventDispatcher } from "svelte";

  import SearchPopup from "./SearchPopup.svelte";
  import Icon from "../ui/Icon.svelte";

  const dispatch = createEventDispatcher();

  let visible = false;
  const handleSelectResult = (event) => {
    dispatch("select", event.detail);
    visible = false;
  };

  const handleHide = () => {
    visible = false;
  };
</script>

{#if visible}
  <SearchPopup on:select={handleSelectResult} on:hide={handleHide} />
{:else}
  <div class="cna-search-button" on:click={() => (visible = true)}>
    <Icon name="search" width={12} />
  </div>
{/if}

<style>
  .cna-search-button {
    position: fixed;
    left: 10px;
    top: 180px;
    box-shadow: 0 0 0 2px rgb(0 0 0 / 10%);
    border-radius: 4px;
    width: 29px;
    height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: white;
  }
</style>
